<template>
    <div class="ms-2 me-auto mb-2 d-flex">
        <h2 class="flex-grow-1 mb-0">
            {{ category.name }}
            <span class="badge bg-primary rounded-pill">{{
                category.recipe_count
            }}</span>
        </h2>
        <h3>
            <a
                :href="category_url"
                class="btn btn-outline-secondary"
                :title="category.name"
                >View All {{ category.name }} Recipes</a
            >
        </h3>
    </div>
</template>

<script>
export default {
    name: "CategoryHeadingBar",
    props: ["category"],
    data() {
        return {
            category_url: "/categories/" + this.category.slug,
        };
    },
};
</script>
<style scoped></style>
